import {SET_SPARES_CUSTOMER_TYPE_LIST} from "../../Actions/ActionConstants";

const CustomerTypeListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_CUSTOMER_TYPE_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default CustomerTypeListReducer
